import { diInject } from '@di/di';
export class WidgetAdApi {
    constructor(_env) {
        this.ad = diInject(0 /* Token.AD */);
        this.parameters = this.ad.parameters;
        this.customDomain = _env.CUSTOM_AD_DOMAIN;
    }
    trackCustomEvent(eventData) {
        this.ad.tracking.trackCustomEvent(eventData);
    }
    // eslint-disable-next-line
    trackCustomProgressEvent(eventData) {
        // removed in CIA-280
    }
}
